export default "__VITE_ASSET__ZU5vJH8h__"